import { render } from "./04_Services.vue?vue&type=template&id=655865b0&scoped=true"
import script from "./04_Services.vue?vue&type=script&lang=js"
export * from "./04_Services.vue?vue&type=script&lang=js"

import "./04_Services.vue?vue&type=style&index=0&id=655865b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655865b0"]])

export default __exports__